import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import i18n from '../../config/i18n';

const FooterContainer = styled.footer`
  padding: 3em 0;
  position: relative;
  background: #2C3E50;
  color: #6D8093;
`;

const A = styled.a`
  color: #A6B4C1; !important;
  
  &:hover {
    color: white;
  }
`;

const IconLink = styled.a`
  width: 50px;
  height: 50px;
  color: #A6B4C1; !important;
  display: inline-block;
  
  &:hover {
    color: white;
  }
`;

const Icon = styled.i`
  font-size: 30px;
`;

class Footer extends Component {
  render() {
    return (
      <FooterContainer>
        <div className="container text-center" style={{ margin: '20px auto' }}>
          <div className="row">
            <IconLink href="https://twitter.com/fallpreventionq/">
              <Icon className="fab fa-twitter" />
            </IconLink>
            <IconLink href="https://www.facebook.com/fallpreventionapp/">
              <Icon className="fab fa-facebook-f" />
            </IconLink>
            <IconLink href="https://www.instagram.com/ihealthcareclouds/">
              <Icon className="fab fa-instagram" />
            </IconLink>
            <IconLink href="https://www.linkedin.com/company/10436370/">
              <Icon className="fab fa-linkedin-in" />
            </IconLink>
            <IconLink href="https://www.pinterest.com/ihealthcareclouds/">
              <Icon className="fab fa-pinterest-p" />
            </IconLink>
            <IconLink href="https://www.youtube.com/c/Nonstopdatasolution_nds">
              <Icon className="fab fa-youtube" />
            </IconLink>
          </div>
          <div className="row">
            {i18n.t('copyright', { year: moment().format('YYYY') })}
          </div>
          <div className="row">
            <A href="/frequently-asked-questions">
              {i18n.t('faq')}
            </A>
            {i18n.t('commaSymbol')}
            <A href="/user-agreement">
              {i18n.t('userAgreement')}
            </A>
            {i18n.t('commaSymbol')}
            <A href="/privacy-policy">
              {i18n.t('privacyPolicy')}
            </A>
            {i18n.t('and')}
            <A href="/privacy-statement">
              {i18n.t('privacyStatement')}
            </A>
          </div>
        </div>
      </FooterContainer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js